module.exports = __webpack_public_path__ + "img/75.26f88110.svg";